import React from 'react'
import { ApolloProvider } from '@apollo/client'

import './App.css'
import client from './apollo/client'
import styled from 'styled-components'
// import Header from './components/header'
// import Footer from './components/footer'
import Navigator from './components/navigator'

const Container = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  height: 100vh;
`

function App() {
  return (
    <ApolloProvider client={client}>
      <Container>
        <Navigator />
      </Container>
    </ApolloProvider>
  )
}

export default App
